/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/


export enum PartNumberChangesTrialStatusEnum {
    REJECTED = 'rejected',
    ACCEPTED = 'accepted'
}
